"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageTypes = exports.cssImage = exports.cssBGImage = void 0; // .......... CSS IMAGES .......... //
// background image

var cssBGImage = {
  backgroundColor: 'transparent',
  backgroundPosition: '50%',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat' // backgroundImage will be placed per unique style

}; // general image settings

exports.cssBGImage = cssBGImage;
var cssImage = {
  backgroundColor: 'transparent',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '50%',
  display: 'inline-block',
  verticalAlign: 'middle',
  '&:hover': {
    transition: 'all .2s linear 0s'
  }
}; // image types

exports.cssImage = cssImage;
var imageTypes = {
  icon: {
    extend: cssImage
  },
  logo: {
    extend: cssImage
  },
  graphic: {
    extend: cssBGImage
  },
  photo: {
    extend: cssBGImage
  }
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.imageTypes = imageTypes;